import React, { useEffect, useRef, useState } from 'react';
import { QrCode, Download, CheckCircle, Smartphone } from 'lucide-react';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент для отображения QR-кода для mailto-ссылки
 */
const QRCodeDisplay = ({ mailtoLink, onDownload }) => {
  const canvasRef = useRef(null);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadComplete, setDownloadComplete] = useState(false);

  useEffect(() => {
    if (!mailtoLink || !canvasRef.current) return;

    // Функция для отрисовки QR-кода на канвасе
    const generateQRCode = async () => {
      try {
        // Импортируем библиотеку QRCode.js
        // В реальном проекте нужно добавить ее в зависимости
        const QRCode = await import('qrcode');
        
        // Генерируем QR-код
        await QRCode.toCanvas(canvasRef.current, mailtoLink, {
          width: 220,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        });
        
        // Создаем URL для скачивания
        setDownloadUrl(canvasRef.current.toDataURL('image/png'));
      } catch (error) {
        console.error('Ошибка при генерации QR-кода:', error);
      }
    };

    generateQRCode();
  }, [mailtoLink]);

  // Обработчик скачивания QR-кода
  const handleDownload = () => {
    if (!downloadUrl) return;
    
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'mailto-qrcode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setDownloadComplete(true);
    if (onDownload) onDownload();
    
    setTimeout(() => {
      setDownloadComplete(false);
    }, 2000);
  };

  if (!mailtoLink) return null;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
        <QrCode className="w-5 h-5 mr-2 text-indigo-500" />
        QR-код для ссылки
      </h3>

      <div className="flex flex-col items-center justify-center">
        <div className="bg-white p-3 rounded-lg border border-gray-200 mb-4">
          <canvas ref={canvasRef} className="mx-auto block" />
        </div>

        <Button
          onClick={handleDownload}
          disabled={!downloadUrl}
          primary={!downloadComplete}
          success={downloadComplete}
          icon={downloadComplete ? <CheckCircle className="w-4 h-4" /> : <Download className="w-4 h-4" />}
        >
          {downloadComplete ? 'Скачано!' : 'Скачать QR-код'}
        </Button>
      </div>

      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3 text-sm text-blue-700 dark:text-blue-300">
        <div className="flex items-start">
          <Smartphone className="w-4 h-4 mr-2 flex-shrink-0 mt-0.5" />
          <p>
            QR-код можно добавить на визитки, рекламные материалы или вывески. При сканировании 
            смартфоном пользователь сможет сразу же написать вам письмо.
          </p>
        </div>
      </div>
    </div>
  );
};

export default QRCodeDisplay;